<template>
	<div class="warehouse-detail">
		<div class="box">
			<div class="d-flex justify-content-between">
				<div class="d-flex w-75">
					<img
						class="img-cover"
						src="https://s3.ir-thr-at1.arvanstorage.ir/public-maan/stock.png"
					/>
					<div class="d-flex flex-column justify-content-center mr-5">
						<span class="mb-2">نام کالا: {{ detailData.name_fa }}</span>
						<span class="mb-2">کد کالا: {{ detailData.identifier }}</span>
						<span class="mb-2">نوع کالا: {{ detailData.type.verbose_name }}</span>
						<span class="persian-number"
							>موجودی پروژه:
							{{ detailData.locations_stock_count + detailData.users_stock_count }}</span
						>
					</div>
				</div>

				<div class="d-flex flex-column justify-content-center w-25">
					<span class="mb-2 persian-number">مقدار ورودی: </span>
					<span class="mb-2 persian-number">مقدار مصرف شده: </span>
					<span class="mb-2 persian-number"
						>موجودی در انبار: {{ detailData.locations_stock_count }}</span
					>
					<span class="persian-number">موجودی نزد افراد: {{ detailData.users_stock_count }}</span>
				</div>
			</div>
			<div class="d-flex justify-content-end w-100">
				<button
					class="toggle-btn"
					@click="toggleBackgroundColor"
					:style="{ background: buttonBackgroundColor, color: buttonTextColor }"
				>
					{{ buttonText }}
				</button>
			</div>
		</div>
		<div class="box">
			<Tableview
				:hover="true"
				:bordered="true"
				:showNoContent="showContnetFunc"
				:showNoData="showDataFunc"
			>
				<template #TableTitle>
					<tr>
						<th>ردیف</th>
						<th>نام انبار/فرد</th>
						<th>مقدار موجودی</th>
						<th>عملیات</th>
					</tr>
				</template>

				<template v-if="buttonBackgroundColor === '#2d8b8b'" #TableBody>
					<tr v-for="(item, index) in getLocationDataLists" :key="item.id">
						<td class="persian-number">
							{{ index + 1 }}
						</td>
						<td>{{ item.location.name_fa }}</td>
						<td class="persian-number">{{ item.stock_count }}</td>
						<td>
							<button
								@click="openstockModal(item)"
								v-b-tooltip.hover
								title="افزایش موجودی"
								class="opt-btn"
							>
								<img src="@/assets/images/iconPack/solar_add-square-broken.svg" />
							</button>
							<button @click="openUseModal(item)" v-b-tooltip.hover title="مصرف" class="opt-btn">
								<img src="@/assets/images/iconPack/use.svg" />
							</button>
							<button
								@click="openRelocateModal(item)"
								v-b-tooltip.hover
								title="انتقال به انبار"
								class="opt-btn"
							>
								<img src="@/assets/images/iconPack/relocate.svg" />
							</button>

							<button
								@click="openDeliverModal(item)"
								v-b-tooltip.hover
								title="انتقال به کاربر"
								class="opt-btn"
							>
								<img src="@/assets/images/iconPack/deliver.svg" />
							</button>
						</td>
					</tr>
				</template>
				<template v-else #TableBody>
					<tr v-for="(item, index) in getUserDataLists" :key="item.id">
						<td class="persian-number">
							{{ index + 1 }}
						</td>
						<td>{{ item.user.first_name }} {{ item.user.last_name }}</td>
						<td class="persian-number">{{ item.stock_count }}</td>
						<td>
							<button
								@click="openUseModal(item)"
								v-b-tooltip.hover
								title="انتقال به مصرف"
								class="opt-btn"
							>
								<img src="@/assets/images/iconPack/use.svg" />
							</button>
							<button
								@click="openRelocateModal(item)"
								v-b-tooltip.hover
								title="انتقال به انبار"
								class="opt-btn"
							>
								<img src="@/assets/images/iconPack/relocate.svg" />
							</button>

							<button
								@click="openDeliverModal(item)"
								v-b-tooltip.hover
								title="انتقال به کاربر"
								class="opt-btn"
							>
								<img src="@/assets/images/iconPack/deliver.svg" />
							</button>
						</td>
					</tr>
				</template>
			</Tableview>
			<b-modal size="lg" v-model="useModal" hide-footer centered>
				<div class="my-4">
					<div>مقدار مصرفی مورد نظر خود را وارد کنید.</div>
					<label>مقدار: </label>
					<input v-model="useInputValue" class="inputs mb-3" />
					<b-form-textarea
						id="textarea"
						v-model="textarea"
						placeholder="توضیحات"
						rows="3"
						max-rows="6"
						class="mb-3"
					></b-form-textarea>
					<div class="d-flex justify-content-end">
						<button :disabled="disabledUseBtn" @click="submitUseModal" class="confirm-item">
							ثبت
						</button>
					</div>
				</div>
			</b-modal>
			<b-modal size="lg" v-model="relocateModal" hide-footer centered>
				<div class="my-4">
					<div>مقدار مصرفی مورد نظر خود را وارد کنید.</div>
					<div class="d-flex justify-content-between align-items-center mb-3">
						<div class="w-100">
							<label>مقدار: </label>
							<input v-model="useInputValue" class="inputs w-75" />
						</div>
						<div class="d-flex justify-content-end align-items-end w-100">
							<label for="html">انبار:</label>
							<select v-model="pickLocation" class="inputs w-75">
								<option v-for="location in locationLists" :value="location.id" :key="location.id">
									{{ location.name_fa }}
								</option>
							</select>
						</div>
					</div>
					<b-form-textarea
						id="textarea"
						v-model="textarea"
						placeholder="توضیحات"
						rows="3"
						max-rows="6"
						class="mb-3"
					></b-form-textarea>
					<div class="d-flex justify-content-end">
						<button :disabled="disabledUseBtn" @click="submitUseModal" class="confirm-item">
							ثبت
						</button>
					</div>
				</div>
			</b-modal>
			<b-modal size="lg" v-model="deliverModal" hide-footer centered>
				<div class="my-4">
					<div>مقدار مصرفی مورد نظر خود را وارد کنید.</div>
					<div class="d-flex justify-content-between align-items-center mb-3">
						<div class="w-100">
							<label>مقدار: </label>
							<input v-model="useInputValue" class="inputs w-75" />
						</div>
						<div class="d-flex justify-content-end align-items-end w-100">
							<label for="html">نیروی اجرایی:</label>
							<select v-model="pickPromoter" class="inputs w-75">
								<option
									v-for="promoter in promoterLists"
									:value="promoter.user.id"
									:key="promoter.id"
								>
									{{ promoter.user.first_name }} {{ promoter.user.last_name }}
								</option>
							</select>
						</div>
					</div>
					<b-form-textarea
						id="textarea"
						v-model="textarea"
						placeholder="توضیحات"
						rows="3"
						max-rows="6"
						class="mb-3"
					></b-form-textarea>
					<div class="d-flex justify-content-end">
						<button :disabled="disabledUseBtn" @click="submitUseModal" class="confirm-item">
							ثبت
						</button>
					</div>
				</div>
			</b-modal>
			<b-modal size="lg" v-model="stockModal" hide-footer centered>
				<div class="my-4">
					<div>مقدار ورودی مورد نظر خود را وارد کنید.</div>
					<div class="d-flex justify-content-between align-items-center mb-3">
						<div class="w-100">
							<label>مقدار: </label>
							<input v-model="useInputValue" class="inputs w-25" />
						</div>
					</div>

					<div class="d-flex justify-content-end">
						<button @click="submitUseModal" class="confirm-item">ثبت</button>
					</div>
				</div>
			</b-modal>
		</div>
	</div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';
export default {
	components: {
		Tableview,
	},
	data() {
		return {
			apiData: null,
			buttonBackgroundColor: '#2d8b8b',
			buttonTextColor: '#fff',
			buttonText: 'نمایش موجودی نزد افراد',
			getLocationDataLists: 0,
			getUserDataLists: [],
			promoterLists: [],
			locationLists: [],
			totalDataCount: 0,
			page: 1,
			detailData: {},
			useModal: false,
			relocateModal: false,
			deliverModal: false,
			useInputValue: null,
			stockModal: false,
			pickPromoter: '',
			pickLocation: '',
			columnData: {},
			condition: 'LOCATION',
			textarea: null,
			wareId: null,
			toState: null,
		};
	},
	mounted() {
		this.makeApiCall('location');
	},
	computed: {
		disabledUseBtn() {
			if (
				this.useInputValue === null ||
				this.useInputValue === '' ||
				this.useInputValue > this.columnData.stock_count
			) {
				return true;
			} else {
				return false;
			}
		},
		showContnetFunc() {
			return this.getLocationDataLists === 0;
		},
		showDataFunc() {
			if (this.getLocationDataLists.length !== undefined) {
				return this.getLocationDataLists.length === 0;
			}
			return false;
		},
	},
	methods: {
		toggleBackgroundColor() {
			if (this.buttonBackgroundColor === '#2d8b8b') {
				this.makeApiCall('user');
				this.buttonBackgroundColor = '#fff';
				this.buttonTextColor = '#2d8b8b';
				this.buttonText = 'نمایش موجودی انبار';
				this.condition = 'USER';
			} else {
				this.makeApiCall('location');
				this.buttonBackgroundColor = '#2d8b8b';
				this.buttonTextColor = '#fff';
				this.buttonText = 'نمایش موجودی نزد افراد';
				this.condition = 'LOCATION';
			}
		},
		openUseModal(data) {
			this.useModal = !this.useModal;
			this.columnData = data;
			this.toState = null;
		},
		openRelocateModal(data) {
			this.relocateModal = !this.relocateModal;
			this.toState = 'LOCATION';
			this.columnData = data;
			this.getLocationLists();
		},
		openDeliverModal(data) {
			this.deliverModal = !this.deliverModal;
			this.columnData = data;
			this.toState = 'USER';
			this.getPromoterLists();
		},
		openstockModal(data) {
			this.stockModal = !this.stockModal;
			this.columnData = data;
			this.toState = 'LOCATION';
		},
		async makeApiCall(apiParam, limit = 20, offset = 0) {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			this.wareId = lastParam;
			this.apiData = null;
			this.buttonBackgroundColor = '#2d8b8b';
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.WAREHOUSE_USER_LOCATION_RETRIEVE +
					this.wareId +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&limit=' +
					limit +
					'&offset=' +
					offset +
					'&based_on=' +
					apiParam,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				if (this.buttonBackgroundColor === '#2d8b8b') {
					this.detailData = res.data;
					this.getLocationDataLists = res.data.locations;
				} else {
					this.getUserDataLists = res.data.users;
				}
			}
		},
		async submitUseModal() {
			const data = {
				lines: [
					{
						ware: this.wareId,
						amount: parseInt(this.useInputValue * -1),
						location: this.stockModal
							? null
							: this.condition === 'LOCATION'
							? this.columnData.location.id
							: null,
						user: this.stockModal
							? null
							: this.condition === 'USER'
							? this.columnData.user.id
							: null,
						side: 'FROM',
						involved: this.stockModal ? null : this.condition,
					},
					{
						ware: this.wareId,
						amount: parseInt(this.useInputValue),
						location: this.stockModal
							? this.columnData.location.id
							: this.toState === 'LOCATION'
							? this.pickLocation
							: null,
						user: this.toState === 'USER' ? this.pickPromoter : null,
						side: 'TO',
						involved: this.toState,
					},
				],
				description: this.textarea,
			};
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.POST.WARE_TRANSACTION +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
				data,
			);
			if (res.status === 200) {
				this.useModal = false;
				this.relocateModal = false;
				this.deliverModal = false;
				this.stockModal = false;
				this.useInputValue = null;
				this.pickPromoter = '';
				this.textarea = null;
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'انتقال با موفقیت انجام شد.',
				});
				this.makeApiCall('location');
				this.buttonTextColor = '#fff';
			}
		},
		async getPromoterLists() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_PROMOTER_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				'promoter:', res.data;
				this.promoterLists = res.data;
			}
		},
		async getLocationLists() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.LOCATION_LIST_CREATE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				this.locationLists = res.data;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.warehouse-detail {
	padding: 32px 50px;
	.box {
		.persian-number {
			font-family: 'IRANYekanfa' !important;
		}
		padding: 24px;
		border-radius: 8px;
		margin-bottom: 16px;
		background: #fff;
		border-radius: 8px;
		box-shadow: none;
		.img-cover {
			width: 128px;
			height: 128px;
		}
		.toggle-btn {
			margin-top: 20px;
			border: 1px solid #2d8b8b;
			border-radius: 8px;
			color: #2d8b8b;
			background: #fff;
			border-radius: 8px;
			padding: 12px;
		}
		.opt-btn {
			border: none;
			background: #fff;
			margin-left: 4px;
			border: 1px solid #2d8b8b;
			border-radius: 8px;
			padding: 4px;
			img {
				width: 24px;
				height: 24px;
			}
		}
	}
}
.inputs {
	margin-top: 16px;
	width: 25%;
	height: 38px;
	border: 1px solid #c4c4c4;
	padding: 0 9px;
	border-radius: 8px;
	margin-right: 4px;
}
.confirm-item {
	background: none;
	padding: 8px;
	border: 1px solid #2d8b8b;
	border-radius: 8px;
	background: #2d8b8b;
	color: #fff;
	margin-left: 8px;
	min-width: 75px;
	&:disabled {
		border: none;
		background: #c4c4c4;
	}
}
.reject-item {
	border: 1px solid #2d8b8b;
	background: #fff;
	color: #000;
	width: 75px;
	border-radius: 8px;
	color: #2d8b8b;
	padding: 8px;
}
</style>
<style>
.VuePagination__count {
	display: none;
}
.page-item.active .page-link {
	background-color: #2d8b8b;
	border-radius: 8px;
}
.page-link {
	border: none;
	color: black;
	font-family: 'IRANYekanfa' !important;
}
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input {
	border: none !important;
	border-radius: 0;
	font-family: 'IRANYekanfa';
}
.vpd-input-group input:disabled {
	background: #fff;
	text-align: center;
	min-width: 130px;
}
</style>
